import { MeasureProgress } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/MeasureProgress";
import { TimeHorizon } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/TimeHorizon";
import { TransportNeed } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/TransportNeed/TransportNeed";
import { AltTransStretchCoverage } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { InfrastructureResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/responseSchema";
import { Dispatch, FC, SetStateAction } from "react";
import { tokens } from "shared/components/Spor";
import styled from "styled-components";

const EventPanelsGrid = styled.div`
  container-type: inline-size;
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr) minmax(0, 1fr);
  grid-template-areas: "time-horizon transport-need event-progression";
  gap: ${tokens.default.size.spacing[2]};
  width: 100%;
  position: relative;
  align-items: stretch;

  @container (width < 2276px) {
    grid-template-columns: 270px minmax(0, 1fr);
    grid-template-areas:
      "time-horizon transport-need"
      "event-progression event-progression";
  }
`;

const EventPanelArea = styled.div<{ $gridArea: string }>`
  grid-area: ${({ $gridArea }) => $gridArea};
  min-width: 0;
  width: 100%;
  height: 100%;
`;

type InfrastructureEventSummaryPanelsProps = {
  event: InfrastructureResponse;
  selectedStretch: AltTransStretchCoverage | null;
  setSelectedStretch: (stretch: AltTransStretchCoverage | null) => void;
  showAllStretches: boolean;
  setShowAllStretches: Dispatch<SetStateAction<boolean>>;
};

export const InfrastructureEventSummaryPanels: FC<
  InfrastructureEventSummaryPanelsProps
> = ({
  event,
  selectedStretch,
  setSelectedStretch,
  showAllStretches,
  setShowAllStretches,
}) => (
  <EventPanelsGrid>
    <EventPanelArea $gridArea="time-horizon">
      <TimeHorizon event={event} />
    </EventPanelArea>
    <EventPanelArea $gridArea="transport-need">
      <TransportNeed
        showAllStretches={showAllStretches}
        selectedStretch={selectedStretch}
      />
    </EventPanelArea>
    <EventPanelArea $gridArea="event-progression">
      <MeasureProgress
        showAllStretches={showAllStretches}
        setShowAllStretches={setShowAllStretches}
        stretch={selectedStretch}
        setStretch={setSelectedStretch}
        incidentId={event.incidentId}
      />
    </EventPanelArea>
    {/* Use when you have data */}
    {/* <CustomerAdvisors advisors={advisors} /> */}
  </EventPanelsGrid>
);
